export const businessBenefits = [
  {
    title: 'Appointments bookings',
    description: 'Stay on top of bookings with a simple calendar. Add, rebook or cancel in seconds.',
  },
  {
    title: 'Client communications',
    description: 'Reduce no-shows and save time with automated reminders and client updates.',
  },
  {
    title: 'Services and locations for your pet business',
    description: 'Run multiple grooming salons, clinics, or offer multiple services? Manage all bookings in one place.',
  },
  {
    title: 'Staff, shifts and schedule management',
    description: 'Add unlimited team members. Organise shifts, time off and services without the admin load.',
  },
];
